import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const printOrder = (user: User, ordid: string) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getorderreport",
		params: {
			userid: user.userId,
			ordid,
		},
	});
};

export default printOrder;
